import { RSAA } from 'redux-api-middleware';
import getAgeGroupsURL from 'url-constructors/getAgeGroupsURL';
import { Dispatch } from 'redux';
import { TAsyncDispatchResult, TGetRootState } from 'types/shared';

const REQUEST = 'opus/ageGroups/REQUEST';
const SUCCESS = 'opus/ageGroups/SUCCESS';
const FAILURE = 'opus/ageGroups/FAILURE';

type AgeGroupsActionTypes = typeof REQUEST | typeof SUCCESS | typeof FAILURE;

type AgeGroupIds = { ageGroupIds: string[] };

interface IAgeGroupsState {
  pending: boolean;
  fulfilled: boolean;
  error: boolean;
  reason: any;
  data: AgeGroupIds[];
}

interface IAgeGroupsAction {
  type: AgeGroupsActionTypes;
  payload: AgeGroupIds[];
}

const initialState: IAgeGroupsState = {
  pending: false,
  fulfilled: false,
  error: false,
  reason: null,
  data: [],
};

function reducer(
  state: IAgeGroupsState = initialState,
  action: IAgeGroupsAction
): IAgeGroupsState {
  switch (action.type) {
    case REQUEST: {
      return {
        ...state,
        pending: true,
        fulfilled: false,
        error: false,
      };
    }
    case SUCCESS: {
      return {
        ...state,
        pending: false,
        fulfilled: true,
        error: false,
        data: action.payload,
      };
    }
    case FAILURE: {
      return {
        ...state,
        pending: false,
        fulfilled: false,
        error: true,
        reason: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

function loadAgeGroups(customerIds?: number): TAsyncDispatchResult {
  return async function (
    dispatch: Dispatch,
    getState: TGetRootState
  ): Promise<any> {
    const { ageGroups } = getState();
    return await dispatch({
      [RSAA]: {
        bailout: ageGroups.pending || ageGroups.fulfilled,
        types: [
          REQUEST,
          {
            type: SUCCESS,
            payload: async function payload(
              action: IAgeGroupsAction,
              state: IAgeGroupsState,
              res: any
            ): Promise<AgeGroupIds[]> {
              const json = await res.json();
              return json;
            },
          },
          FAILURE,
        ],
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        method: 'GET',
        endpoint: getAgeGroupsURL(customerIds),
      },
    });
  };
}

export { loadAgeGroups };
export default reducer;
